'use strict';

/**
 * TV Animal Chooser
 *
 * Responsibilities:
 *  - Highlight the icon of the animal group holding the selected option.
 *  - Submit: navigate to the comparison target of the selected option.
 *  - Sticky behaviour (mobile bottom CTA / desktop pinned top).
 *
 * Desktop: when the form scrolls out of view, pin the full chooser to the top
 * with a placeholder. CSS position:sticky cannot be used here — the parent is
 * too short, so sticky would stop almost immediately.
 */
(function() {
    // Keep in sync with $tv-desktop-breakpoint in tv-animal-chooser.scss
    var MOBILE_BREAKPOINT = '(max-width: 1279px)';
    var ACTIVE_GROUP_CLASS = 'tv-animal-chooser__group--active';

    // ------------------------------------------------------- selection styling
    function initActiveGroup(form) {
        function update() {
            var selected = form.querySelector('input[name="target"]:checked');
            var activeGroup = selected && selected.closest('.tv-animal-chooser__group');

            form.querySelectorAll('.tv-animal-chooser__group').forEach(function(group) {
                group.classList.toggle(ACTIVE_GROUP_CLASS, group === activeGroup);
            });
        }

        form.addEventListener('change', update);
        update();
    }

    // ------------------------------------------------------------------- submit
    function initSubmit(form) {
        form.addEventListener('submit', function(event) {
            // The form never posts anywhere — the selected option carries its own
            // comparison target, so navigation is always handled here.
            event.preventDefault();

            var selected = form.querySelector('input[name="target"]:checked');
            var target = selected && selected.dataset.url;
            if (target) {
                window.location.href = target;
            }
        });
    }

    // --------------------------------------------------------- sticky behaviour

    function getVisibleOnscroll() {
        var containers = document.querySelectorAll('.tv-animal-chooser__onscroll');
        for (var i = 0; i < containers.length; i++) {
            if (containers[i].offsetParent !== null) {
                return containers[i];
            }
        }
        return null;
    }

    function initMobileStickyBar(container) {
        var form = container.querySelector('.tv-animal-chooser__form');
        var stickyBar = container.parentElement
            && container.parentElement.querySelector('.tv-animal-chooser__sticky-bar');
        if (!form || !stickyBar) {
            return;
        }

        stickyBar.querySelector('.tv-animal-chooser__button').addEventListener('click', function() {
            if (typeof form.requestSubmit === 'function') {
                form.requestSubmit();
            } else {
                form.submit();
            }
        });

        if (!('IntersectionObserver' in window)) {
            return;
        }

        // Observe the submit CTA, not the outer wrapper — the wrapper also contains
        // the subtitle (flex order:-1), so it can stay "intersecting" long after
        // the button has scrolled out of view on pages with a short subtitle.
        var observeTarget = container.querySelector('.tv-animal-chooser__submit')
            || container.querySelector('.tv-animal-chooser__shell')
            || form;

        var observer = new IntersectionObserver(function(entries) {
            var barIsVisible = !entries[0].isIntersecting;
            stickyBar.classList.toggle('tv-animal-chooser__sticky-bar--visible', barIsVisible);
            // Read by the tracking map to tell the sticky CTA from the main one.
            form.dataset.sticky = barIsVisible ? 'true' : 'false';
        });
        observer.observe(observeTarget);
    }

    function initDesktopStickyTop(container) {
        var placeholder = document.createElement('div');
        placeholder.style.display = 'none';
        container.parentNode.insertBefore(placeholder, container);

        var form = container.querySelector('.tv-animal-chooser__form');
        var isSticky = false;

        // Read by the tracking map to tell the sticky CTA from the main one.
        function markSticky(value) {
            if (form) {
                form.dataset.sticky = value ? 'true' : 'false';
            }
        }

        function makeSticky() {
            if (isSticky) {
                return;
            }
            placeholder.style.display = 'block';
            placeholder.style.height = container.offsetHeight + 'px';
            container.classList.add('tv-animal-chooser__onscroll--sticky');
            isSticky = true;
        }

        function makeUnsticky() {
            if (!isSticky) {
                return;
            }
            container.classList.remove('tv-animal-chooser__onscroll--sticky');
            placeholder.style.display = 'none';
            placeholder.style.height = '0';
            isSticky = false;
        }

        var sentinel = document.createElement('div');
        sentinel.style.height = '1px';
        sentinel.style.marginBottom = '-1px';
        sentinel.style.pointerEvents = 'none';
        container.parentNode.insertBefore(sentinel, placeholder);

        if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
                        makeSticky();
                    } else if (entry.isIntersecting) {
                        makeUnsticky();
                    }
                });
            }, { threshold: 0 });
            observer.observe(sentinel);
        } else {
            var onScroll = function() {
                if (sentinel.getBoundingClientRect().top < 0) {
                    makeSticky();
                } else {
                    makeUnsticky();
                }
            };
            window.addEventListener('scroll', onScroll, { passive: true });
            onScroll();
        }
    }

    // --------------------------------------------------------------------- init

    function init() {
        var container = getVisibleOnscroll();
        if (!container) {
            return;
        }

        var form = container.querySelector('.tv-animal-chooser__form');
        if (form) {
            initActiveGroup(form);
            initSubmit(form);
        }

        if (window.matchMedia(MOBILE_BREAKPOINT).matches) {
            initMobileStickyBar(container);
        } else {
            initDesktopStickyTop(container);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
